<div class="build-your-course">
  <lx-layout
    [title]="title()"
    [subtitle]="subtitle()"
    [shareableDeeplink]="shareableDeeplink()"
    [valid]="shareableLinkAvailability()"
    [copied]="shareableLinkCopyStatus()"
    (copyRequested)="handleCopyRequested()"
  >
    <div layout-main>
      <div class="build-your-course__selectors">
        <!-- Course Intensity Selector -->
        <div class="build-your-course__section">
          <lx-course-intensity-selector
            [availableCourses]="availableCourses()"
            [selectedCourse]="selectedCourse()"
            (courseSelected)="selectCourse($event)"
            (compareCoursesClicked)="openCourseSelector()"
          ></lx-course-intensity-selector>
        </div>

        <!-- Duration Selector -->
        <div class="build-your-course__section">
          <lx-duration-selector
            [minWeeks]="minWeeks()"
            [maxWeeks]="maxWeeks()"
            [selectedDuration]="selectedDuration()"
            (durationSelected)="selectDuration($event)"
          ></lx-duration-selector>
        </div>

        <!-- Start Date Selector -->
        <div class="build-your-course__section">
          <lx-start-date-selector
            [selectedStartDate]="selectedStartDate()"
            [selectedEndDate]="selectedEndDate()"
            [calendarConfig]="calendarConfig()"
            (startDateSelected)="selectStartDate($event)"
          ></lx-start-date-selector>
        </div>
      </div>
    </div>

    <!-- Sidebar with Summary -->
    <div layout-sidebar>
      @if (!mobile()) {
      <p-card>
        <lx-course-summary [courseSummary]="courseSummary()" data-qa="course-summary"></lx-course-summary>
      </p-card>
      <div class="build-your-course__book-now">
        <lx-button
          i18n-text
          text="Book now"
          [block]="true"
          [buttonStyle]="'primary'"
          [disabled]="!formValid()"
          [lxGAClickEvent]="bookNowEventName"
          data-qa="book-now-button"
          (buttonClick)="onBookNow()"
        >
        </lx-button>
      </div>
      } @else {
      <div class="build-your-course__sticky-total-price-footer-container">
        <lx-sticky-total-price-footer
          [courseSummary]="courseSummary()"
          data-qa="sticky-total-price-footer"
          [bookNowEventName]="bookNowEventName"
          [formValid]="formValid()"
          (onBookNow)="onBookNow()"
        >
        </lx-sticky-total-price-footer>
      </div>
      }
    </div>
  </lx-layout>
</div>

<lx-side-panel
  i18n-title
  title="Select a course"
  size="large"
  [visible]="courseSelectorDialogVisible()"
  (hiddenPanel)="closeCourseSelector()"
  data-qa="onlineCourseSelector_sidePanel"
>
  <lx-online-course-selector
    [courseOptions]="courseOptions()"
    titlePathName="shortName"
    [initialSelectedCourse]="selectedCourse()"
    [currentDuration]="selectedDuration()"
    [currentStartDate]="selectedStartDate()"
    (selectedCourseChanged)="selectCourseFromComparedCourses($event)"
  ></lx-online-course-selector>
</lx-side-panel>
